<template>
  <div class="PartTime">
    <div class="header">
      <div class="inner_center">
        <h1>让创意设计轻松变现</h1>
        <h2>潮国创意设计师招募</h2>
        <div class="subhead">
          平台曝光+高薪收入，为你的设计保驾护航
        </div>
        <div class="consult-btn title-wrap" @click="toSign">
          <i class="icon_smile"/>
          立即签约
          <!--          <div class="dropbox" >
                      <div class="dropbox-item">
                        {{ ' 春节放假时间：1月16日-1月29日' }}
                      </div>
                    </div>-->
        </div>
        <div class="icon_person-wrap">
          <i class="icon_person">
          </i>
        </div>

      </div>
    </div>
    <div class="main inner_center">
      <!-- 我们需要 -->
      <div class="main-module we-need">
        <h3>
          <i class="we-need"/>
          我们需要
        </h3>
        <div class="we-need-content">
          <div class="we-need-panel personal-designer">
            <div class="panel-title">个人设计师</div>
            <div class="panel-word">DESIGNER</div>
            <ul class="panel-advantage">
              <li
                v-for="(vo,idx) in ADVANTAGE_LIST.PERSONAL_DESIGNER"
                :key="idx"
                class="panel-advantage-item">
                <i class="iconfont icon-gou"/>
                <span>{{ vo }}</span>
              </li>
            </ul>
            <div class="consult-btn" @click="openQQ(SIGN_TYPE.PERSON)">设计师签约</div>
            <i class="icon_illus"/>
            <i class="icon_lock"/>
          </div>
          <div class="we-need-panel work-room">
            <div class="panel-title">工作室</div>
            <div class="panel-word">WORKSHOP</div>
            <ul class="panel-advantage">
              <li
                v-for="(vo,idx) in ADVANTAGE_LIST.WORD_ROOM"
                :key="idx"
                class="panel-advantage-item">
                <i class="iconfont icon-gou"/>
                <span>{{ vo }}</span>
              </li>
            </ul>
            <div class="consult-btn" @click="openQQ(SIGN_TYPE.WORK_ROOM)">工作室签约</div>
            <i class="icon_illus"/>
            <i class="icon_lock"/>
          </div>
        </div>
      </div>

      <!-- 急需岗位/主题 -->
      <div class="main-module job-subject">
        <h3>
          <i class="we-job"/>
          急需岗位/主题
        </h3>
        <MenuNav
          class="MenuNav"
          :nav-index="navIndex"
          :navIsClick="false"
          :menu-nav-list="JOB_NAV.LIST"
          @toggleMenu="toggleMenu"
        />
        <div class="pic-list">
          <div
            v-for="(vo,idx) in JOB_NAV.LIST[navIndex].picList"
            :key="idx"
            class="pic-item">
            <img
              :src=" IMG_BASE_URL + vo + '!/fw/558/quality/90/unsharp/true/compress/true' "
              class="pic-img"
              alt="">
            <TupianMask :link="PAGE_PATH.BASE_URL + PAGE_PATH.PART_TIME"/>
          </div>
        </div>
      </div>

      <!-- 简单4步，开启创意设计 -->
      <div class="main-module designer-step">
        <h3>简单4步，开启创意设计</h3>
        <div class="designer-step-content">
          <div
            v-for="(vo,idx) in DESIGNER_STEP" :key="idx"
            class="step-item-wrap">
            <div class="step-item">
              <i class="step-item-icon" :class="'step-item-icon-'+(idx+1) "/>
              <div class="step-item-title">{{ vo.label }}</div>
            </div>
            <i class="icon-right"/>
          </div>

        </div>
      </div>

      <div class="join-pic">
        <div class="pic-title">
          欢迎加入潮国创意<br>
          开启灵感碰撞
        </div>
        <div class="pic-subhead">
          隐藏在茫茫人海中的宝藏创意人就是你
        </div>
        <div class="consult-qq">
          如有其他问题，请咨询负责人QQ：
          <span @click="openQQ">1589503219</span>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import {MenuNav} from "@/components/home/index.js"
import {ADVANTAGE_LIST, JOB_NAV, DESIGNER_STEP} from "./module";
import {IMG_BASE_URL} from '@/constant/PATH'
import {PAGE_PATH} from '@/constant/PAGE_PATH'
import {fnLayout, fnLogin} from "@/fn";
import TupianMask from '@/components/tupian/tupian-mask'
import {getContractExpire, getSignStatus} from "@/api/creator/sign";
import axios from "axios";

const dayjs = require('dayjs');

const {
  DEFAULT,
  LOADING,
  FAIL,
  CONTRACT,
  CONTRACT_FAIL,
  SUCCESS,
} = CON_COMMON.CON_CREATOR.SIGN_STATUS

const {SIGN_TYPE} = CON_COMMON.CON_CREATOR


/* 引入公共方法和常量 */
import * as fnCommon from '@/fn/_fn';
import * as CON_COMMON from '@/constant/_constant';
import {CREATOR, CREATOR_SIGN, CREATOR_SIGN_WRITE} from "@/constant/_constant/CON_BASIC";

export default {
  name: "PartTime",
  layout: "header-nav",
  components: {
    MenuNav,
    TupianMask
  },
  head() {
    return {
      title: '潮国创意设计师招募-让设计作品轻松变现,在家也能拿高薪',
      meta: [
        {
          hid: 'keywords',
          name: 'keywords',
          content: '设计师招募,潮国创意'
        },
        {
          hid: 'description',
          name: 'description',
          content: '潮国创意是目前国内为设计师、创意机构和创作人员寻找高质量、吸睛创意设计资源的素材图片网站。包含各类潮流前沿、高品质正版原创图片素材，chaopx.com 是值得信懒、可商用的潮流设计网站。'
        }
      ]
    }
  },
  data() {
    return {
      ADVANTAGE_LIST,
      JOB_NAV,
      DESIGNER_STEP,
      IMG_BASE_URL,
      navIndex: 0,
      PAGE_PATH,
      SIGN_TYPE
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      fnLayout.setFooterBgColor();
    },
    toggleMenu(idx) {
      this.navIndex = idx;

    }

    ,toSign(){

      if (fnLogin.checkLogin()){
        fnCommon.fnBasic.navigationTo(CON_COMMON.CON_BASIC.CREATOR);
      }else{
        fnLogin.loginIntercept(false)
      }

    }
    ,async openQQ(signType) {
      /* let path = 'http://wpa.qq.com/msgrd?v=3&uin=1589503219&site=qq&menu=yes'
       // let path = 'http://wpa.qq.com/msgrd?v=3&uin=1598542395&site=qq&menu=yes'
       window.open(path, '_blank');*/

      /* 进入创作者中心后台 */
      fnCommon.fnBasic.navigationTo(CON_COMMON.CON_BASIC.CREATOR)
      return false;
      if (fnLogin.checkLogin()) {
        let res = await getSignStatus()

        if (res.data.status == 404) {
          /* 未提交资料 */
          // redirect(CON_COMMON.CON_BASIC.CREATOR_SIGN)
          // fnCommon.fnBasic.navigationTo(CON_COMMON.CON_BASIC.CREATOR_SIGN, "_self");
          const _redirectPath = CON_COMMON.CON_BASIC.CREATOR_SIGN_WRITE + `?type=${signType}`
          fnCommon.fnBasic.navigationTo(_redirectPath);

        } else if (res.data.status == 200) {
          let type = "";
          if (res.data.data) {
            let {status} = res.data.data;
            if (status == 1 || status == 4) {
              // 审核中
              type = LOADING;
            } else if (status == 2 || status == 5) {
              // 审核成功
              type = CONTRACT;

            } else if (status == 3 || status == 6) {
              // 审核失败
              type = FAIL;

            } else if (status == 7) {
              // 签约成功
              type = SUCCESS;
              /* 不在鉴权 */
              console.log('签约成功')
            }


            let _redirectPath = CON_COMMON.CON_BASIC.CREATOR_SIGN_PROGRESS + `?type=${type}`;
            fnCommon.fnBasic.navigationTo(_redirectPath);


            /*if (status != 7) {
              redirect(CON_COMMON.CON_BASIC.CREATOR_SIGN_PROGRESS + `?type=${type}`);
            }else{

            }*/
          }
        }


      }else{
        fnLogin.loginIntercept(false)
      }

    }
  }
}
</script>

<style lang="scss" scoped>

.inner_center {
  width: 1200px !important;
}


.PartTime {

  .header {
    width: 100%;
    height: 448px;
    //@include BgImage(100%, 448px, 'part-time/header@bg.png', 1);
    background: linear-gradient(232.31deg, #FFC397 -2.16%, #FC96BB 41.73%, #A690FC 81.52%, #6969FF 97.54%);

    > .inner_center {
      height: 100%;
      position: relative;

      .icon_person-wrap {
        @include Position(1, 3, 0, -16px);

        &:after {
          content: '';
          display: inline-block;
          width: 380px;
          height: 380px;
          -webkit-backdrop-filter: blur(20px);
          border-radius: 50%;
          z-index: 9;
          background-color: rgba(252, 154, 183, 0.2);

          background: linear-gradient(134.29deg, rgba(255, 255, 255, 0.395952) 3.31%, rgba(255, 255, 255, 0.1) 55.87%);
          box-shadow: 0px 2px 40px -1px rgba(252, 154, 183, 0.197416);
          backdrop-filter: blur(27.1828px);
        }
      }

      .icon_person {
        @include BgImage(412px, 453px, 'part-time/header@person.png');
        @include Position(1, 3, 0, -26px);
        z-index: 10;
        /*.icon_circle{
          //@include BgImage(412px, 453px, 'part-time/icon_circle.png');
          display: inline-block;
          width: 380px;
          height: 380px;
          background: linear-gradient(134deg, rgba(255, 255, 255, 0.3) 0%, rgba(255, 255, 255, 0.05) 100%);
          box-shadow: 0 2px 40px -1px rgba(0, 17, 144, 0.19);
          -webkit-backdrop-filter: blur(50px);
          backdrop-filter: blur(50px);
          border-radius: 50%;
          z-index: -1;
        }*/

      }
    }

    h1 {
      font-size: 64px;
      font-weight: bold;
      color: #FFFFFF;
      line-height: 74px;
      letter-spacing: 4px;
      padding: 74px 0 6px;
    }

    h2 {
      font-size: 46px;
      font-weight: bold;
      color: rgba(251, 247, 255, 0.9000);
      line-height: 62px;
      letter-spacing: 4px;
    }

    .subhead {
      font-size: 18px;
      color: #F4ECFF;
      line-height: 24px;
      letter-spacing: 2px;
      margin: 40px 0 32px;
    }

    .consult-btn {
      width: 238px;
      height: 60px;
      background: linear-gradient(224deg, #FFB6A2 0%, #FC83AE 100%);
      box-shadow: 0px 0px 0px 3px rgba(251, 247, 255, 0.2000);
      border-radius: 34px;
      font-size: 20px;
      color: #FFFFFF;
      letter-spacing: 2px;
      line-height: 60px;
      text-align: center;
      cursor: pointer;

      .icon_smile {
        @include BgImage(24px, 24px, 'part-time/icon_smile.png');
      }

      @include ElementHover('', '') {
        background: linear-gradient(224deg, #FC83AE 0%, #FFB6A2 100%);
        box-shadow: 0px 0px 0px 3px rgba(251, 247, 255, 0.3500);
        border-radius: 34px;
      }
    }


  }

  .main {

    /* 抽取公共模块 */
    .main-module {
      h3 {
        font-size: 44px;
        font-weight: bold;
        color: #2D2B33;
        line-height: 58px;
        letter-spacing: 2px;
        text-align: center;
        //margin: 85px 0 66px;
      }
    }

    .we-need {
      margin-bottom: 125px;
      display: flex;
      flex-direction: column;
      align-items: center;

      h3 {
        display: inline-block;
        margin: 88px 0 87px;
        position: relative;

        .we-need {
          @include BgImage(145px, 60px, 'part-time/h3%40we-need.svg');
          @include Position(1, 2, -46px, 0);
          z-index: -1;
        }

      }

      .we-need-content {
        display: flex;


        @mixin PanelItem(
          $panel-title-color:transparent,
          $consult-btn-hover: transparent,
          $panel-word-color:transparent,
          $icon_illus:''
        ) {
          position: relative;
          .panel-title {
            font-size: 32px;
            font-weight: bold;
            color: $panel-title-color;
            line-height: 43px;
            letter-spacing: 2px;
          }
          .panel-word {
            font-size: 28px;
            color: $panel-word-color;
            line-height: 37px;
            letter-spacing: 6px;
            margin-bottom: 20px;
          }
          .panel-advantage {
            width: 446px;
            height: 192px;
            background: #FFFFFF;
            border-radius: 14px;
            padding: 40px 0 0 48px;
            box-sizing: border-box;
            margin-bottom: 20px;

            li {
              font-size: 0;
              display: flex;
              align-items: center;
              margin-bottom: 20px;

              &:last-child {
                margin-bottom: 0;
              }

              .icon-gou {
                font-size: 24px;
                margin-right: 16px;
                color: $color-success;
              }

              span {
                font-size: 18px;
                color: #2D2B33;
                line-height: 24px;
              }
            }
          }
          .consult-btn {
            width: 446px;
            height: 72px;
            background: $panel-title-color;
            border-radius: 14px;
            font-size: 24px;
            font-weight: bold;
            color: #FFFFFF;
            letter-spacing: 2px;
            text-align: center;
            line-height: 72px;

            @include ElementHover('', $consult-btn-hover)
          }

          .icon_illus {
            //@include BgImage(156px, 156px, 'part-time/#{$icon_illus}.png?v=1');
          }
        }


        .we-need-panel {
          margin-right: 123px;
          padding: 49px 0 0 50px;
          box-sizing: border-box;

          &:last-child {
            margin-right: 0;
          }

          &.personal-designer {
            @include BgImage(548px, 489px, 'part-time/personal-designer@bg.png?v=1');
            @include PanelItem(#8767FF, #795CE8, rgba(133, 108, 240, 0.2), 'icon_illus@illus');

            .icon_illus {
              @include BgImage(150px, 133px, 'part-time/icon_illus@illus.png?v=1');
              @include Position(1, 2, 64px, 30px);
            }

            .icon_lock {
              @include BgImage(23px, 41px, 'part-time/work-room@loop.svg');
              @include Position(1, 4, 65px, 120px);

            }
          }

          &.work-room {
            @include BgImage(548px, 489px, 'part-time/work-room@bg.png?v=1');
            @include PanelItem(#177AFF, #146DE8, rgba(23, 122, 255, 0.2), 'icon_illus%40computer');

            .icon_illus {
              @include BgImage(100px, 133px, 'part-time/icon_illus%40computer.png?v=1');
              @include Position(1, 2, 64px, 30px);
            }

            .icon_lock {
              @include BgImage(23px, 41px, 'part-time/personal-designer@loop.svg');
              @include Position(1, 3, 67px, 120px);
            }

          }
        }
      }
    }

    .job-subject {
      h3 {
        display: inline-block;
        position: relative;

        .we-job {
          @include BgImage(145px, 60px, 'part-time/h3%40job.svg');
          @include Position(1, 4, -40px, 0);
          z-index: -1;
        }
      }

      margin-bottom: 105px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      /deep/ .MenuNav {
        width: 100%;
        margin: 48px 0 40px !important;

        .menu-nav-list {
          width: 1200px !important;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .menu-nav-item {
          width: 118px;
        }
      }

      .pic-list {
        display: flex;

        .pic-item {
          width: 279px;
          height: 365px;
          border-radius: 14px;
          margin-right: 28px;
          overflow: hidden;
          transition: all 0.5s ease-in-out;
          position: relative;

          @include ElementHover('', '') {
            box-shadow: 0px 8px 16px 0px rgba(213, 221, 236, 0.4000);
            img {
              transform: scale(1.1);
            }
          }

          &:last-child {
            margin-right: 0;
          }

          img {
            width: 100%;
            transition: all 0.5s ease-in-out;
          }
        }
      }
    }

    .designer-step {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      margin-bottom: 92px;

      .designer-step-content {
        margin-top: 80px;
        display: flex;

        .step-item-wrap {
          display: flex;

          &:last-child {
            .icon-right {
              display: none;
            }
          }

          .step-item {
            @mixin StepItem($pngName) {
              @include BgImage(172px, 172px, 'part-time/step-item@#{$pngName}.png')
            }

            .step-item-icon {
              margin-bottom: 24px;

              &.step-item-icon-1 {
                @include StepItem(1);
              }

              &.step-item-icon-2 {
                @include StepItem(2);
              }

              &.step-item-icon-3 {
                @include StepItem(3);
              }

              &.step-item-icon-4 {
                @include StepItem(4);
              }
            }

            .step-item-title {
              font-size: 18px;
              color: #2D2B33;
              line-height: 24px;
            }
          }

          .icon-right {
            @include BgImage(20px, 20px, 'part-time/icon-purple-right.svg');
            margin: 70px 56px 0;
          }
        }


      }

    }

    .join-pic {
      @include BgImage(100%, 288px, 'part-time/join-pic@bg.png');
      display: flex;
      align-items: center;
      flex-direction: column;
      position: relative;
      margin-bottom: 80px;

      .pic-title {
        font-size: 40px;
        font-weight: bold;
        color: #FFFFFF;
        line-height: 54px;
        letter-spacing: 3px;
        margin: 60px 0 9px;
        text-align: center;
      }

      .pic-subhead {
        font-size: 14px;
        color: #F4ECFF;
        line-height: 19px;
        letter-spacing: 1px;
      }

      .consult-qq {
        @include BgImage(350px, 46px, 'part-time/consult-qq@bg.png');
        @include Position(1, 4, 50%, 0);
        transform: translateX(-50%);

        font-size: 13px;
        color: #E8D8FF;
        line-height: 46px;
        text-align: center;

        span {
          text-decoration: underline;
          cursor: pointer;

          @include ElementHover(#FBF8FF, '');
        }

      }
    }


  }
}


.title-wrap {
  color: #424866;
  position: relative;

  &:hover {
    .dropbox {
      display: block;
    }
  }

  .dropbox {
    @include Position(1, 5, 50%, 72px);
    transform: translateX(-50%);
    z-index: 9;
    background: #424866;
    border-radius: 8px;
    display: none;


    &:after {
      content: '';
      display: inline-block;
      width: 10px;
      height: 10px;
      background: #424866;
      @include Position(1, 5, 50%, -5px);
      transform: translateX(-50%) rotate(135deg);
    }

    .dropbox-item {
      //width: 200px;
      height: 28px;
      line-height: 28px;
      padding: 0px 8px;
      font-size: 12px;
      color: #FFFFFF;
      white-space: nowrap;

      &:last-child {
        margin-bottom: 0;
      }

    }
  }
}
</style>
